// test1705
(1705 && 0);
